import { render, staticRenderFns } from "./File.vue?vue&type=template&id=e446201e&scoped=true&"
import script from "./File.vue?vue&type=script&lang=js&"
export * from "./File.vue?vue&type=script&lang=js&"
import style0 from "./File.vue?vue&type=style&index=0&id=e446201e&prod&lang=scss&scoped=true&"
import style1 from "./File.vue?vue&type=style&index=1&id=e446201e&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e446201e",
  null
  
)

export default component.exports